import React, { useEffect, useState } from 'react';
import { Table, Button, Card, Spinner, Row, Col, Alert } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PrinterFill } from "@styled-icons/bootstrap/PrinterFill";

//Actions
import { pesquisaformatoacesso as pesquisatodos } from '../../../../actions/credenciamento/credencial';
import { camposelect, campotexto } from '../../../../components/forms/campos/campos';
import { setUserLoginCred } from '../../../../utils/eventosessioncred';

import { getEvento } from '../../../../utils/eventosession';

import { getPastaPromotora } from '../../../../helpers/promotoraPasta';

const PesquisaCredenciamento = (props) => {

    const [evento,setEvento] = useState({});
    const [credenciais,setCredenciais] = useState([]);
    
    const handleCarregaPesquisa = async (form) => {
        const params = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            [form.campo]: form.dados
        }
        
        setCredenciais(await props.pesquisatodos({
            ...params
        }))
    }

    const handleCarregaAcesso = (credencial) => {
        setUserLoginCred({...credencial, email: credencial.fisica.email});
        const url = `${window.location.protocol}//${window.location.host}/app/credenciamento/${getPastaPromotora(evento.idpromotora)}/${evento.ideventocriptografado}/produtos`;
        window.open(url, "_BLANK");
    }

    const handleLinkImpressaoCredencial = (credencial) => {
        const code = Buffer.from(`${credencial.idcredencial}`).toString('base64');
        const url = `https://regtronweb.com.br/cidtechweb/api/credenciais/credencial/link/impressao?idpromotora=${evento.idpromotora}&idevento=${evento.idevento}&linguagem=pt&aplicacao=credenciamento&idcredencial=${code}`;
        window.open(url, "_BLANK");
    }

    useEffect(() => {
        setEvento(getEvento());
    },[props.eventoSelecionado]);

    return (
        <Form
        onSubmit={handleCarregaPesquisa}
        validate={(form) => {
            const errors = {};
            if(!form.dados){
                errors.dados = "Obrigatório";
            }

            if(!form.campo){
                errors.campo = "Obrigatório";
            }
            return errors;
        }}
        render={({form, submitting, handleSubmit}) => {
            return (
                <form onSubmit={handleSubmit}>
                <Card>
                    <Card.Header>Pesquisar Credencial</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                            <Field 
                            label="Escolha o Filtro"
                            name="campo" 
                            options={[{value: "", texto: "Escolha"},{value: "nome", texto: "Nome"},{value: "cpf", texto: "CPF"},{value: "email", texto: "E-mail"}]} 
                            component={camposelect} />
                        </Col>
                        <Col>
                            <Field label="Dados para Pesquisa" name="dados" placeholder="Informe o dado de pesquisa" component={campotexto} />
                        </Col>
                        <Col>
                            <Button type="submit" className="mt-4" block disabled={submitting}>{submitting?<Spinner animation="border" />:"Pesquisar"}</Button>
                        </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>CPF</th>
                        <th>Acessar</th>
                        <th>Imprimir</th>
                        </tr>
                    </thead>
                    <tbody>
                        {credenciais.length?credenciais.map((itens, index)=> {
                            
                            return (
                                <tr key={index}>
                                <td>{itens.fisica.nome+' '+itens.fisica.sobrenome}</td>
                                <td>{itens.fisica.email}</td>
                                <td>{itens.fisica.cpf}</td>
                                <td><Button variant="info" onClick={() => handleCarregaAcesso(itens)}>Ir</Button></td>
                                <td><Button variant="secondary" onClick={() => handleLinkImpressaoCredencial(itens)}><PrinterFill size="2em" /></Button></td>
                                </tr>
                            );
                        }):submitting?"":<tr><td colSpan="5"><Alert variant="warning" block>Nenhum resultado para mostrar</Alert></td></tr>}                
                    </tbody>
                </Table>
                </form>
            );
        }}
        />        
    )    
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks,
        eventoSelecionado: state.reducerEventoSelecionado
    }
}

export default connect(mapStateToProps,{pesquisatodos})(withRouter(PesquisaCredenciamento));